import { render, staticRenderFns } from "./PrinterStation.vue?vue&type=template&id=5bc46d8a&scoped=true&"
import script from "./PrinterStation.vue?vue&type=script&lang=js&"
export * from "./PrinterStation.vue?vue&type=script&lang=js&"
import style0 from "../../../../src/assets/css/printer-station.css?vue&type=style&index=0&id=5bc46d8a&scoped=true&lang=css&"
import style1 from "./PrinterStation.vue?vue&type=style&index=1&id=5bc46d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc46d8a",
  null
  
)

export default component.exports